import React from "react";
import { Text } from "@chakra-ui/react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import TextField from "src/components/TextField";
import LoadableContent from "src/components/LoadableContent";
import { updateUser } from "src/modules/auth/duck/epics";
import { withApp } from "src/components/App/Context";
import { getFamilyName } from "src/modules/auth/duck/selectors";

const log = window.require("electron-log");

class RenameFamilyDialog extends React.Component {
  state = {
    error: false,
    familyName: this.props.familyName || "",
    isProcessing: false
  };

  onFamilyNameChange = (e) => {
    this.setState({ familyName: e.target.value });
  };
  handleFamilyRename = async () => {
    const { familyName } = this.state;
    if (!familyName || familyName?.length === 0) return;
    try {
      this.setState({ isProcessing: true });
      const { dispatch, app } = this.props;
      await dispatch(updateUser({ familyName, app }));
      this.props.onDismiss();
    } catch (error) {
      log.error(error);
      this.setState({ isProcessing: false, error: true });
    }
  };

  resetState = () => {
    this.setState({ error: false, isProcessing: false });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.handleFamilyRename();
  };
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render() {
    const { error, familyName, isProcessing } = this.state;
    const { onDismiss, t, isOpen } = this.props;

    return (
      <Dialog
        modalProps={{
          onCloseComplete: this.resetState
        }}
        isOpen={isOpen}
        onClose={onDismiss}
        isProcessing={isProcessing}
        text={t("myAccount.renameFamilyDialog.text")}
        heading={t("myAccount.renameFamilyDialog.heading")}
        buttons={[
          { text: t("buttons.cancel"), onClick: onDismiss },
          {
            text: t("buttons.save"),
            onClick: this.handleFamilyRename
          }
        ]}
        additionalContent={
          <>
            <TextField
              autoFocus
              width="296px"
              value={familyName}
              placeholder={t("placeholders.familyName")}
              onChange={this.onFamilyNameChange}
              type="text"
            />
            <LoadableContent showContent={error} showSpinner={false}>
              <Text mt="4px" color="red" fontSize="11px">
                {t("myAccount.renameFamilyDialog.failure")}
              </Text>
            </LoadableContent>
          </>
        }
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    familyName: getFamilyName(state)
  };
}
const enhance = compose(withApp, connect(mapStateToProps), withTranslation());

export default enhance(RenameFamilyDialog);
